import React from 'react';
import Type from '../../dropdown/customerwithmobile';
import Chip from '@material-ui/core/Chip';
import { Form, TextArea, Button } from 'semantic-ui-react'
import TagFacesIcon from '@material-ui/icons/TagFaces';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Customerdetails from '../../others/customerdetails';
import Template from './templates';

class Single extends React.Component {

  state = {
    data: [],
    message: '',
    customer: ''
  }

  update(value, data) {
    let items = [];
    data.map((z) =>{
      if (value == z.id) {
        if (z.mobile) {
          items.push({ mobile: z.mobile })
        }
        if (z.alt_mobile) {
          items.push({ mobile: z.alt_mobile })
        }
      }
    });
    this.setState({ data: items, customer: value })
  }

  remove(value) {
    let data = this.state.data;
    let items = [];
    data.map((z) => {
      if (value == z.mobile) {

      }
      else {
        items.push(z);
      }
    })
    this.setState({ data: items })
  }

  send() {
    let context = this;
    let message = this.state.message;
    let data = this.state.data;
    var dups = [];
    var items = data.filter(function(el) {
      if (dups.indexOf(el.mobile) == -1) {
        dups.push(el.mobile);
        return true;
      }
      return false;
    });
    if (items.length <= 0) {
      alert('Select the Customer');
      return;
    }
    if (message == '' || message == undefined || message == null) {
      alert('Enter the message')
      return;
    }
    items = JSON.stringify(items);
    let data1 = { 'data': items, 'message': message };
    context.setState({
      load: true,
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'sms/send.php',
      success: function(data)
      {
        alert('Message Send Successfully!!!!')
        context.setState({
          message: '',
          load: false
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  removeDuplicate() {
    let data = this.state.data;
    var dups = [];
    var arr = data.filter(function(el) {
      if (dups.indexOf(el.mobile) == -1) {
        dups.push(el.mobile);
        return true;
      }
      return false;
    });
    return arr;
  }


  template(template) {
    this.setState({ message: template })
  }

  render() {
    let data = this.removeDuplicate();
    let customerDetails = (<div></div>);
    if (this.state.customer.length >= 1) {
      customerDetails = (<Customerdetails customerId={this.state.customer} />)
    }
    return (
      <div style={{height: 700, padding: '1%'}}>
        <Loading load={this.state.load} message={'Sending sms!!!'} />
        <Type update={this.update.bind(this)} />
        {customerDetails}
        <br/><br/>

          { (data) ?
            (
              <div style={{display: 'flex', flexFlow: 'row nowrap', paddingLeft: '37%'}}>

                { data.map((z) => {
                    return(
                      <div>
                        <Chip style={{width: '100%', fontSize: 18}} label={z.mobile} onDelete={this.remove.bind(this, z.mobile)} />
                      </div>
                    )
                  })
                }
              </div>
            ) :
            (
              <div></div>
            )
          }
          <br/><br/>
          <Form>
            <TextArea rows={10} onChange={e => this.setState({ message: e.target.value })}
             value={this.state.message}
             placeholder='Enter the message' />
          </Form>
          <Template template={this.template.bind(this)} />
          <br/>
        <center>
          {
            this.props.menuPermission.add ?
            <Button primary onClick={this.send.bind(this)}>Send</Button>: ''
          }
        </center>
      </div>
    );
  }
}

export default Single;
